"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _SingletonListener_listeners, _SingletonListener_callbacks;
Object.defineProperty(exports, "__esModule", { value: true });
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const sentry_1 = __importDefault(require("../development/sentry"));
const singleton_1 = __importDefault(require("../immutable/singleton"));
/**
 * SingletonListener
 *
 * An event handler manager to minimize the number of subscription to DOM objects
 */
class SingletonListener {
    constructor(target = null) {
        this.target = null;
        _SingletonListener_listeners.set(this, new Map());
        _SingletonListener_callbacks.set(this, new Map()
        /**
         * return the total of subscription to this listener
         */
        );
        this.target = target;
    }
    /**
     * Check for previous instance to return, otherwise create new one
     *
     * @param target listener target
     */
    static from(target) {
        const id = (0, singleton_1.default)(target);
        if (!this.cache.has(id)) {
            this.cache.set(id, new SingletonListener(target));
        }
        return this.cache.get(id);
    }
    /**
     * return the total of subscription to this listener
     */
    get size() {
        let result = 0;
        for (const listeners of __classPrivateFieldGet(this, _SingletonListener_listeners, "f").values()) {
            result += listeners.length;
        }
        return result;
    }
    /**
     * Create a physical subscription to a target event
     * @param event
     */
    subscribe(event) {
        if (__classPrivateFieldGet(this, _SingletonListener_callbacks, "f").has(event)) {
            console.warn(`Already subscribed to "${event}"`);
            return this;
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        const callback = function (data) {
            const listeners = __classPrivateFieldGet(_this, _SingletonListener_listeners, "f").get(event) || [];
            for (const listener of listeners) {
                try {
                    listener.call(this, data);
                }
                catch (err) {
                    console.error(`Error executing listener: ${err.message}`, err);
                    (0, rollbar_1.default)((rollbar) => rollbar.error(`Error executing listener: ${err.message}`, err));
                    (0, sentry_1.default)((sentry) => sentry.captureException(`Error executing listener: ${err.message}`, {
                        extra: err,
                    }));
                    (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: `Error executing listener: ${err.message}`, stack: err.stack })));
                }
            }
        };
        if (this.target) {
            this.target.addEventListener(event, callback);
        }
        __classPrivateFieldGet(this, _SingletonListener_callbacks, "f").set(event, callback);
        return this;
    }
    /**
     * Remove a virtual subscription to a target event
     * if there aren't any more virtual subscription then
     * will remove the physical subscription
     *
     * @param event
     */
    unsubscribe(event) {
        const listeners = __classPrivateFieldGet(this, _SingletonListener_listeners, "f").get(event);
        if (listeners && listeners.length) {
            __classPrivateFieldGet(this, _SingletonListener_listeners, "f").set(event, []);
        }
        const callback = __classPrivateFieldGet(this, _SingletonListener_callbacks, "f").get(event);
        if (callback) {
            __classPrivateFieldGet(this, _SingletonListener_callbacks, "f").delete(event);
            if (this.target) {
                this.target.removeEventListener(event, callback);
            }
        }
        return this;
    }
    /**
     * Dispatch and event to all virtual subscriptions
     * @param event
     * @param data
     */
    dispatch(event, data) {
        const target = this.target;
        const callback = __classPrivateFieldGet(this, _SingletonListener_callbacks, "f").get(event);
        return Promise.resolve().then(() => {
            if (callback) {
                callback.call(target, data);
            }
        });
    }
    /**
     * Create a virtual subscription to the target
     *
     * @param event
     * @param listener
     */
    addEventListener(event, listener) {
        const listeners = __classPrivateFieldGet(this, _SingletonListener_listeners, "f").get(event) || [];
        listeners.push(listener);
        if (listeners.length === 1) {
            this.subscribe(event);
        }
        __classPrivateFieldGet(this, _SingletonListener_listeners, "f").set(event, listeners);
        return this;
    }
    /**
     * Remove a virtual subscription to the target
     * @param event
     * @param listener
     */
    removeEventListener(event, listener) {
        const listeners = __classPrivateFieldGet(this, _SingletonListener_listeners, "f").get(event);
        if (!listeners || listeners.length === 0) {
            return this.unsubscribe(event);
        }
        const newListeners = listeners.filter((l) => l !== listener);
        if (newListeners.length === 0) {
            return this.unsubscribe(event);
        }
        __classPrivateFieldGet(this, _SingletonListener_listeners, "f").set(event, newListeners);
        return this;
    }
}
exports.default = SingletonListener;
_SingletonListener_listeners = new WeakMap(), _SingletonListener_callbacks = new WeakMap();
/**
 * instance store
 */
SingletonListener.cache = new Map();
